<div class="bmc-power-bi-detail">
  <label class="bmc-power-bi-detail__title" *ngIf="isConexion">{{powerBIConfiguration.DisplayName}}</label>
  <label class="bmc-power-bi-detail__title" *ngIf="!isConexion">{{reportConfiguration.DisplayName}}</label>

  <div class="bmc-power-bi-detail__container">
    <div class="bmc-power-bi-detail__label" *ngIf="isConexion" [innerHtml]="powerBIConfiguration.Description | safeHtml"></div>

    <div *ngIf="isConexion">
      <bzg-input [(ngModel)]="powerBIConfiguration.ClientId" [placeholder]="'POWERBI.EXAMPLEGUID' | translate" required>
        {{'POWERBI.CLIENTID' | translate}}
        <bzg-required-error>{{'POWERBI.FIELD_REQUIRED' | translate}}</bzg-required-error>
      </bzg-input>
      <div *ngIf="showErrorGuid(powerBIConfiguration.ClientId)" class="showError">{{'POWERBI.INVALID_GUID' | translate}}</div>

      <div class="bmc-power-bi-detail__title_secret">{{'POWERBI.SECRETID' | translate}} *</div>
      <div class="bz-input-icon">
        <input class="bz-input bz-input-icon__input bz-space--inline-s"
          [(ngModel)]="powerBIConfiguration.SecretId" type="{{showEncryptFlag ? 'text':'password'}}"
          (blur)="encryptBasicSecurityPassword()"
          required>
        <svg class="bz-icn bz-space--inline-s cursor-pointer" (click)="showEncrypt()"  height="32px" width="32px">
          <use href="#icon-eye" *ngIf="!showEncryptFlag"></use>
          <use href="#icon-eye-closed" *ngIf="showEncryptFlag"></use>
        </svg>
      </div>
      <div *ngIf="showErrorRequired(powerBIConfiguration.SecretId)" class="showError">{{'POWERBI.FIELD_REQUIRED' | translate}}</div>
      <div *ngIf="passwordEncrypt(powerBIConfiguration.SecretId)" class="showError">{{'POWERBI.INVALID_SECRET' | translate}}</div>
    </div>
    <div *ngIf="!isConexion">
      <bzg-input [(ngModel)]="reportConfiguration.GroupId" [placeholder]="'POWERBI.EXAMPLEGUID' | translate" required>
        {{'POWERBI.WORKSPACEID' | translate}}
        <bzg-required-error>{{'POWERBI.FIELD_REQUIRED' | translate}}</bzg-required-error>
      </bzg-input>
      <div *ngIf="showErrorGuid(reportConfiguration.GroupId)" class="showError">{{'POWERBI.INVALID_GUID' | translate}}</div>

      <bzg-input [(ngModel)]="reportConfiguration.ReportId" [placeholder]="'POWERBI.EXAMPLEGUID' | translate" required>
        {{'POWERBI.REPORTID' | translate}}
        <bzg-required-error>{{'POWERBI.FIELD_REQUIRED' | translate}}</bzg-required-error>
      </bzg-input>
      <div *ngIf="showErrorGuid(reportConfiguration.ReportId)" class="showError">{{'POWERBI.INVALID_GUID' | translate}}</div>
    </div>

    <div class="bmc-power-bi-detail__apply-button">
      <bzg-button-primary type="button" (click)="updateData()" [disabled]="btnDisabled()">
        {{ "GLOBAL.APPLY" | translate }}
      </bzg-button-primary>
    </div>
  </div>
</div>
